var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTirageHebdo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.0032 34.415L10.3121 46.6527C9.36084 47.0592 8.40077 46.0982 8.80639 45.1459L21.0334 16.4258C21.3514 15.6768 22.3261 15.488 22.901 16.0629L39.3622 32.5424C39.937 33.1172 39.7503 34.0928 39.0003 34.4121H39.0032V34.415Z",
    fill: "url(#paint0_linear_6602_39962)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5931 33.7194C42.5051 31.8057 39.8312 26.0237 34.6207 20.8081C29.4102 15.5924 23.6363 12.9178 21.7243 14.8315C19.8123 16.7453 22.4862 22.5273 27.6967 27.7429C32.9072 32.9586 38.6811 35.6361 40.596 33.7194H40.5931Z",
    fill: "url(#paint1_linear_6602_39962)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4532 10.4571C34.8816 10.4571 35.6494 10.4088 36.0042 10.5881C36.2879 11.0043 35.5743 13.2135 35.2478 13.6763C35.1168 13.8618 34.4454 13.8322 34.2154 13.8333C33.8094 13.8348 32.8378 13.8973 32.5632 13.7027C32.2833 13.1725 32.9737 11.0956 33.3393 10.5787C33.442 10.4335 34.2509 10.4589 34.4532 10.4571Z",
    fill: "#E52326"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7759 26.182C40.4858 26.1304 40.6999 26.1574 40.69 26.9933C40.6833 27.5511 40.7894 28.4788 40.5893 28.9845C40.173 29.3701 38.9457 29.4435 38.3612 29.5033C38.071 29.5512 37.822 29.6111 37.55 29.4763C37.2372 29.1692 37.2475 26.9789 37.5509 26.6515C37.7911 26.3923 39.385 26.2371 39.7759 26.182Z",
    fill: "#E52326"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6997 17.0586C42.2504 17.0715 43.7473 17.0255 44.1852 17.1388C44.4608 17.3692 44.0885 17.9324 43.9119 18.1566C43.3169 18.9115 43.02 19.8106 41.9164 19.9121C41.5074 19.919 39.4097 19.945 39.2837 19.6401C39.338 19.3685 39.5526 19.0185 39.7276 18.7976C40.3001 18.0749 40.6372 17.1304 41.6997 17.0586Z",
    fill: "#E52326"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0631 9.03126C46.9463 8.94617 47.0727 9.56805 47.2391 10.2872C47.3406 10.7259 47.4235 11.1733 47.4979 11.6179C47.4025 11.713 47.2096 11.847 47.0954 11.9318C46.3799 11.9859 45.6635 12.0273 44.9466 12.056C43.809 12.1188 43.8334 11.2381 43.6388 10.3569C43.5585 9.99306 43.5449 9.66847 43.6134 9.30144C43.885 9.02188 45.5746 9.05131 46.0631 9.03126Z",
    fill: "#E52326"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3412 21.3438C31.7632 21.3396 33.8219 21.5682 34.1081 21.8823C34.3686 22.1682 34.2668 24.1569 34.2498 24.6208C34.243 24.8065 34.1684 24.8333 34.0522 24.9152C33.6604 24.9043 31.4004 24.6437 31.242 24.3068C30.9837 23.7576 31.0762 22.244 31.1338 21.6013C31.1473 21.4512 31.2351 21.4127 31.3412 21.3438Z",
    fill: "#E52326"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6602_39962",
    x1: 32.3912,
    y1: 20.1358,
    x2: -0.66678,
    y2: 48.1324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDA9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0784191,
    stopColor: "#FDA9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.676633,
    stopColor: "#FFC3F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6602_39962",
    x1: 46.2109,
    y1: 14.2025,
    x2: 26.0202,
    y2: 27.5768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.527128,
    stopColor: "#FFC3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.633141,
    stopColor: "#FFC3F8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTirageHebdo);
export default __webpack_public_path__ + "static/media/TirageHebdo.9b1315e880ff78d5898fea6897bc7914.svg";
export { ForwardRef as ReactComponent };